module.exports = __webpack_public_path__ + "img/zerocarbon4.3fc7f545.png";